// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + {"108": "metadata-sidebar","161": "versions-sidebar","233": "docgen-sidebar","315": "skills-sidebar","404": "activity-sidebar","765": "details-sidebar",}[chunkId] + "." + {"108": "f5789329","161": "38a9d022","233": "6c0c3059","315": "6e588193","404": "09fbe375","765": "b48ffcc5",}[chunkId] + ".css"
}